// extracted by mini-css-extract-plugin
module.exports = {"root":"Booking_root__36qIz","submitButton":"Booking_submitButton__1RI9R","disabledBtn":"Booking_disabledBtn__3IaBt"};